module.exports = __webpack_public_path__ + "img/fundo.df7fe322.png";